<template>
  <div class="invoicDetail">
    <el-drawer title="开票详情" :visible.sync="visible" width="480px" :close-on-click-modal="false" :before-close="closeDialog">
      <p>开票进度</p>
      <slot name="status"></slot>
      <p>发票信息</p>
      <el-form ref="form" :model="form" label-width="110px" label-position="left">
        <el-form-item label="开票时间：">
          <span>{{
            moment(form.gmtCreate).format("YYYY/MM/DD HH:mm:ss")
          }}</span>
        </el-form-item>
        <el-form-item label="开票人：">
          <span>{{ form.creatorAccount }}</span>
        </el-form-item>
        <el-form-item label="发票类型：">
          <span>{{ form.invoiceType == 1? "普通发票" : "增值税专票" }}</span>
        </el-form-item>
        <el-form-item label="发票抬头：">
          <span>{{ transferTitle }}</span>
        </el-form-item>
        <el-form-item label="发票金额：">
          <span style="color:#1170EB;font-size:16px" v-show="form.amount">￥{{ form.amount }}</span>
        </el-form-item>
        <el-form-item label="纳税人识别号：">
          <span>{{ form.taxNo }}</span>
        </el-form-item>
        <el-form-item label="地址：">
          <span>{{ form.address }}</span>
        </el-form-item>
        <el-form-item label="电话：">
          <span>{{ form.telephone }}</span>
        </el-form-item>
        <el-form-item label="开户行：">
          <span>{{ form.bank }}</span>
        </el-form-item>
        <el-form-item label="账号：">
          <span>{{ form.bankAccount }}</span>
        </el-form-item>
      </el-form>
      <span class="btns">
        <!-- <el-button size="mini" @click="closeDialog">取消</el-button> -->
        <!-- <el-button type="primary" size="mini" @click="closeDialog" v-if="form.status!=20">确定</el-button> -->
        <!-- <el-button type="primary" size="mini" @click="()=>{$emit('getDownloadUrl',form.invoiceUrl)}" v-if="form.status==1">下载</el-button> -->

      </span>
    </el-drawer>
  </div>
</template>
 
<script>
import moment from "moment"

export default {
  name: "invoicDetail",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: {},
    },
  },
  data () {
    return {
      moment,
      transferTitle: "",
      //   form: {
      //     time: "2021/11/17 10:00:00",
      //   },
    }
  },
  created () {
    this.transferTitle = this.$store.getters.userData.companyName || "--"
  },
  mounted () {
    console.log(this.form)
  },
  methods: {
    closeDialog () {
      this.$parent.visible = false
      this.$parent.getData()
    },
  },
};
</script>
 
<style scoped lang="less">
.invoicDetail {
  ::v-deep .el-drawer__body {
    padding: 0 24px;
  }
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
  p {
    font-weight: bold;
    font-size: 16px;
    padding: 18px 0;
  }
  p:first-child {
    padding-top: 0;
  }
  .btns {
    display: flex;
    justify-content: center;
  }
}
</style>